var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAstronautStandingIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Grupo_12743",
    "data-name": "Grupo 12743",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 26.414,
    height: 40.955,
    viewBox: "0 0 26.414 40.955",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_4508",
    "data-name": "Rect\\xE1ngulo 4508",
    width: 26.414,
    height: 40.955,
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_12742",
    "data-name": "Grupo 12742",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1147",
    "data-name": "Trazado 1147",
    d: "M26.341,22.982A2.92,2.92,0,0,0,25.1,21.2L17.99,17.151a13.715,13.715,0,0,0-.935-1.031,9.424,9.424,0,1,0-14-.878,8.41,8.41,0,0,0-2.84,3.739A3.209,3.209,0,0,0,.02,19.986l0,1.169a.812.812,0,0,0,0,.189L0,29.25a2.711,2.711,0,0,0,2.752,2.695,2.689,2.689,0,0,0,1.057-.216v7.588a.812.812,0,0,0,.45.721,1.434,1.434,0,0,0,1.356.917H9.129a1.475,1.475,0,0,0,1.11-.5,1.477,1.477,0,0,0,1.11.5h3.514a1.477,1.477,0,0,0,1.112-.505,1.46,1.46,0,0,0,.238-.4.814.814,0,0,0,.474-.737V23.552a.8.8,0,0,0,.128.106.821.821,0,0,0,.386.1c.025,0,.048-.007.073-.009l4.848,2.088a2.93,2.93,0,0,0,1.562.454,2.723,2.723,0,0,0,2.283-1.2,2.68,2.68,0,0,0,.375-2.108"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1148",
    "data-name": "Trazado 1148",
    d: "M11.031,2A7.781,7.781,0,1,1,5.557,15.3a.814.814,0,0,0-.192-.206A7.77,7.77,0,0,1,11.031,2",
    transform: "translate(-0.588 -0.362)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1149",
    "data-name": "Trazado 1149",
    d: "M7.088,47.548C7.3,46.385,7.967,45.5,8.654,45.5s1.354.885,1.566,2.048Z",
    transform: "translate(-1.282 -8.231)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1150",
    "data-name": "Trazado 1150",
    d: "M14.088,47.548c.212-1.162.879-2.048,1.566-2.048s1.354.885,1.566,2.048Z",
    transform: "translate(-2.548 -8.231)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1151",
    "data-name": "Trazado 1151",
    d: "M13.467,39.261a2.774,2.774,0,0,0-2.048.97V36.394a.819.819,0,0,0-1.638,0v3.837a2.774,2.774,0,0,0-2.048-.97,2.735,2.735,0,0,0-1.926.854V24.927a.819.819,0,0,0-1.638,0v.852L2,24.465v-.324l.018-.459a1.626,1.626,0,0,1,.09-.495,6.759,6.759,0,0,1,2.438-3.119,9.368,9.368,0,0,0,11.606.729,11.712,11.712,0,0,1,.929,1.017,1.583,1.583,0,0,0,.448.378l1.112.632-1.394,2.6-.37-.161a.805.805,0,0,0-.645-.337.819.819,0,0,0-.819.819V40.132a2.737,2.737,0,0,0-1.943-.871",
    transform: "translate(-0.362 -3.63)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1152",
    "data-name": "Trazado 1152",
    d: "M11.212,16.925A6.962,6.962,0,1,0,4.25,9.962a6.97,6.97,0,0,0,6.962,6.962m0-1.638A5.325,5.325,0,0,1,6.434,12.3a5.224,5.224,0,0,1,5.188-3.561c2.751,0,4.21,1.1,4.464,3.365a5.331,5.331,0,0,1-4.874,3.188m0-10.648a5.333,5.333,0,0,1,5.211,4.235,6.2,6.2,0,0,0-4.8-1.777A7.247,7.247,0,0,0,5.9,9.725a5.326,5.326,0,0,1,5.312-5.087",
    transform: "translate(-0.769 -0.543)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1153",
    "data-name": "Trazado 1153",
    d: "M13.5,24H9.868A1.871,1.871,0,0,0,8,25.869v1.177a1.87,1.87,0,0,0,1.868,1.868H13.5a1.87,1.87,0,0,0,1.868-1.868V25.869A1.871,1.871,0,0,0,13.5,24m.23,3.046a.23.23,0,0,1-.23.23H9.868a.23.23,0,0,1-.23-.23V25.869a.231.231,0,0,1,.23-.231H13.5a.231.231,0,0,1,.23.231Z",
    transform: "translate(-1.447 -4.342)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1154",
    "data-name": "Trazado 1154",
    d: "M3.056,35.331A1.058,1.058,0,0,1,2,34.274v-6.5L4.17,29.088v5.187a1.071,1.071,0,0,1-1.113,1.057",
    transform: "translate(-0.362 -5.024)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1155",
    "data-name": "Trazado 1155",
    d: "M28.664,28.6a1.177,1.177,0,0,1-1.64.246l-4.571-1.978,1.311-2.446,4.269,2.425.227.146a1.285,1.285,0,0,1,.547.777,1.055,1.055,0,0,1-.143.831",
    transform: "translate(-4.062 -4.418)",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAstronautStandingIcon);
export default __webpack_public_path__ + "static/media/astronautStandingIcon.d4c9ee0f826cf37d58b9823b8ac13864.svg";
export { ForwardRef as ReactComponent };